import * as _ from 'lodash';
import { IMatchRunSettings, ISortBy } from '@nkr/models/index';
import { IChainDisplay } from './models';
import { Button, Glyphicon, Row, ToggleButton, ToggleButtonGroup, Well } from 'react-bootstrap';
import { ChainTableWrapper } from './styles';

interface IProps {
    list: IChainDisplay[],
    settings: IMatchRunSettings,
    sortBy: ISortBy[],
    suppressPeds: boolean,
    suppressEpletMM: boolean,
    suppressAge: boolean,
    suppressBloodType: boolean,
    hideSuppressButtons: boolean,
    onSortChanged: (sortBy: ISortBy[]) => void,
    onExpand: (swapIndex: number, chainIndex: number) => void,
    onExpandAll: () => void,
    onSelect: (swapIndex: number, chainIndex: number, rank: number) => void,
    onDeleteSelected: () => void,
    onRestoreDeleted: () => void,
    onSuppressPeds: (suppress: boolean) => void,
    onSuppressEpletMM: (suppress: boolean) => void,
    onSuppressAge: (suppress: boolean) => void,
    onSuppressBloodType: (suppress: boolean) => void
}

const Chains = (props: IProps) => {
    const handleSortChanged = (field: string) => {
        let f = props.sortBy.find(x => x.property == field);

        if (f != null) {
            f.direction = f.direction == 'desc' ? 'asc' : '';
        } else {
            f = {
                property: field,
                direction: 'desc'
            };
        }

        if (f.direction == '') {
            f = null;
        }

        if (f != null) {
            props.onSortChanged([f]);
        } else {
            props.onSortChanged([]);
        }
    };

    const handleExpandAll = () => {
        props.onExpandAll();
    };

    const renderSortIndicator = (field: string) => {
        let f = props.sortBy.find(x => x.property == field);

        if (f != null) {
            let fIndex = props.sortBy.findIndex(x => x.property == f.property);

            if (props.sortBy.length > 1) {
                return <><Glyphicon glyph={f.direction == 'asc' ? 'triangle-top' : 'triangle-bottom'} /><span style={{ fontSize: 10 }}>({fIndex + 1})</span></>;
            } else {
                return <Glyphicon glyph={f.direction == 'asc' ? 'triangle-top' : 'triangle-bottom'} />;
            }
        }

        return null;
    };

    const suppressUnsuppressFilters = () => {
        return (
            <div style={{ display: 'flex', float: 'right', margin: '2px' }}>
                <div className="grid-item" style={{ display: 'flex', alignSelf: 'left', alignItems: 'center', margin: 2 }}>
                    <div style={{ paddingRight: 5 }} title={'Click here to suppress or unsuppress chains that include pediatrics'}><strong>Pediatrics:</strong></div>
                    <ToggleButtonGroup type='radio' name='suppress-peds' value={props.suppressPeds ? 1 : 0}>
                        <ToggleButton type='radio' value={1} className={props.suppressPeds ? 'btn-primary btn-xs' : 'btn-xs'} onClick={() => props.onSuppressPeds(true)}>Suppress</ToggleButton>
                        <ToggleButton type='radio' value={0} className={!props.suppressPeds ? 'btn-primary btn-xs' : 'btn-xs'} onClick={() => props.onSuppressPeds(false)}>Unsuppress</ToggleButton>
                    </ToggleButtonGroup>
                </div>
                <div className="grid-item" style={{ display: 'flex', alignSelf: 'left', alignItems: 'center', margin: 2 }}>
                    <div style={{ paddingRight: 5 }} title={'Click here to suppress or unsuppress chains that do not include pediatrics, RTSF patients, have chains that cannot get a low Eplet MM within 4 months, and have chain ends with medium or high eplet mismatch'}><strong>Eplet MM:</strong></div>
                    <ToggleButtonGroup type='radio' name='suppress-epletmm' value={props.suppressEpletMM ? 1 : 0}>
                        <ToggleButton type='radio' value={1} className={props.suppressEpletMM ? 'btn-primary btn-xs' : 'btn-xs'} onClick={() => props.onSuppressEpletMM(true)}>Suppress</ToggleButton>
                        <ToggleButton type='radio' value={0} className={!props.suppressEpletMM ? 'btn-primary btn-xs' : 'btn-xs'} onClick={() => props.onSuppressEpletMM(false)}>Unsuppress</ToggleButton>
                    </ToggleButtonGroup>
                </div>
                <div className="grid-item" style={{ display: 'flex', alignSelf: 'left', alignItems: 'center', margin: 2 }}>
                    <div style={{ paddingRight: 5 }} title={`Click here to suppress or unsuppress chains that do not include pediatrics and contain an 'O' blood type recipient who is 10+ years older than the donor`}><strong>Age MM:</strong></div>
                    <ToggleButtonGroup type='radio' name='suppress-age' value={props.suppressAge ? 1 : 0}>
                        <ToggleButton type='radio' value={1} className={props.suppressAge ? 'btn-primary btn-xs' : 'btn-xs'} onClick={() => props.onSuppressAge(true)}>Suppress</ToggleButton>
                        <ToggleButton type='radio' value={0} className={!props.suppressAge ? 'btn-primary btn-xs' : 'btn-xs'} onClick={() => props.onSuppressAge(false)}>Unsuppress</ToggleButton>
                    </ToggleButtonGroup>
                </div>
                <div className="grid-item" style={{ display: 'flex', alignSelf: 'left', alignItems: 'center', margin: 2 }}>
                    <div style={{ paddingRight: 5 }} title={`Click here to suppress or unsupress chains with no pediatrics, chain start donor of blood type 'O' and a chain end that doesn't have an 'O' blood type`}><strong>Non-O Voucher:</strong></div>
                    <ToggleButtonGroup type='radio' name='suppress-bloodtype' value={props.suppressBloodType ? 1 : 0}>
                        <ToggleButton type='radio' value={1} className={props.suppressBloodType ? 'btn-primary btn-xs' : 'btn-xs'} onClick={() => props.onSuppressBloodType(true)}>Suppress</ToggleButton>
                        <ToggleButton type='radio' value={0} className={!props.suppressBloodType ? 'btn-primary btn-xs' : 'btn-xs'} onClick={() => props.onSuppressBloodType(false)}>Unsuppress</ToggleButton>
                    </ToggleButtonGroup>
                </div>
            </div>
        )
    }


    const filteredList = props.list.filter(x => x.isDeleted == false);

    return (
        <>
            <div style={{ textAlign: 'right' }}>
                {props.sortBy.length > 1 ?
                    <>scenario sort order: CE ABO - 'O' top, LEN desc, EPM desc, WT desc</>
                    :
                    <>&nbsp;</>
                }
            </div>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 5 }}>
                <div>
                    <Button bsSize='xs' onClick={props.onRestoreDeleted}>Restore Deleted</Button>
                </div>

                {props.sortBy.length <= 1 && props.hideSuppressButtons == false &&
                    <div style={{ maxWidth: 'fit-content', marginLeft: 'auto', marginRight: 'auto' }}>{suppressUnsuppressFilters()}</div>
                }

                {props.sortBy.length > 1 && props.hideSuppressButtons == false &&
                    <div style={{ maxWidth: 'fit-content', marginLeft: 'auto', marginRight: 'auto' }}>{suppressUnsuppressFilters()}</div>
                }
            </div>

            <ChainTableWrapper condensed bordered striped>
                <thead>
                    <tr>
                        <th style={{ width: 35 }} onClick={handleExpandAll}>Exp</th>
                        <th style={{ width: 35 }} onClick={props.onDeleteSelected}>Del</th>
                        <th onClick={() => handleSortChanged('chainId')}># {renderSortIndicator('chainId')}</th>
                        <th onClick={() => handleSortChanged('depth')}>LEN {renderSortIndicator('depth')}</th>
                        <th onClick={() => handleSortChanged('otoORatio')}>O:O {renderSortIndicator('otoORatio')}</th>
                        <th style={{ width: 75 }} onClick={() => handleSortChanged('ageDelta')}>Age Delta {renderSortIndicator('ageDelta')}</th>
                        <th onClick={() => handleSortChanged('donationType')}>D Type {renderSortIndicator('donationType')}</th>
                        <th onClick={() => handleSortChanged('patientType')}>P Type {renderSortIndicator('patientType')}</th>
                        <th onClick={() => handleSortChanged('cpr')}>CPR {renderSortIndicator('cpr')}</th>
                        <th onClick={() => handleSortChanged('maxCpra')}>cPRA4 {renderSortIndicator('maxCpra')}</th>
                        <th onClick={() => handleSortChanged('highestDeclineRatio')}>D/R {renderSortIndicator('highestDeclineRatio')}</th>
                        <th onClick={() => handleSortChanged('numberOfLowRiskEpletMM')}>EPM {renderSortIndicator('numberOfLowRiskEpletMM')}</th>
                        <th onClick={() => handleSortChanged('averageHla')}>HLA {renderSortIndicator('averageHla')}</th>
                        <th onClick={() => handleSortChanged('longestWaitTime')}>WT {renderSortIndicator('longestWaitTime')}</th>
                        <th onClick={() => handleSortChanged('acceptedPreselectStatusPercentage')}>PS {renderSortIndicator('acceptedPreselectStatusPercentage')}</th>
                        <th style={{ width: 75 }} onClick={() => handleSortChanged('voucherHolderAbo')}>CE&nbsp;ABO&nbsp;{renderSortIndicator('voucherHolderAbo')}</th>
                        <th style={{ width: 45 }}>Rank</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredList.map((item, itemIndex) =>
                        <tr key={'chain-' + itemIndex}>
                            <td><input type='checkbox' checked={item.isExpanded} onClick={() => props.onExpand(item.swapIndex, item.chainIndex)} /></td>
                            <td><input type='checkbox' checked={item.isSelected} onClick={() => props.onSelect(item.swapIndex, item.chainIndex, itemIndex + 1)} /></td>
                            <td>{item.swapIndex + '/' + item.chainIndex}</td>
                            <td>{item.chain.depth}</td>
                            <td>{item.chain.otoORatio}</td>
                            <td>{item.chain.ageDelta}</td>
                            <td>{item.chain.donationTypeAbbreviation}</td>
                            <td>{item.chain.patientTypeAbbreviation}</td>
                            <td>{item.chain.cpr < 0 ? "N/A" : _.floor(item.chain.cpr * 100.0)}</td>
                            <td>{item.chain.maxCpra == null ? '--' : item.chain.maxCpra.toFixed(2)}</td>
                            <td>{item.chain.highestDeclineRatio == null ? '--' : (item.chain.highestDeclineRatio * 100.0).toFixed(0)}</td>
                            <td>{item.chain.numberOfLowRiskEpletMM}</td>
                            <td>{item.chain.averageHla}</td>
                            <td>{item.chain.longestWaitTime}</td>
                            <td>{Math.round(item.chain.acceptedPreselectStatusPercentage * 100.0)}</td>
                            <td>{item.chain.voucherHolderAbo != '' ? item.chain.voucherHolderAbo : '--'}</td>
                            <td>{itemIndex + 1}</td>
                        </tr>
                    )}
                </tbody>
            </ChainTableWrapper>

            <div style={{ fontSize: 12 }}>{filteredList.length} chains...</div>
        </>
    );
}

export default Chains;